import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	nccList: [],
	isFetching: false,
	error: false,
};

export const nccSlice = createSlice({
	name: 'ncc',
	initialState,
	reducers: {
		getAll4Store: (state, { payload }) => {
			state.nccList = payload;
		},
		addNcc: (state, { payload }) => {
			state.nccList.push(payload);
		},
		updateNcc: (state, { payload }) => {
			state.nccList[state.nccList.findIndex((item) => item.id === payload.id)] = payload;
		},
		deleteNcc: (state, { payload }) => {
			state.nccList.splice(
				state.nccList.findIndex((item) => item.id === payload),
				1,
			);
		},
	},
});

export const { getAll4Store, addNcc, updateNcc, deleteNcc } = nccSlice.actions;

export default nccSlice.reducer;
